import CancelRoundedIcon from "@mui/icons-material/CancelRounded";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import { Tooltip } from "@mui/material";
import type { WorkbookRunStatus } from "../../../../../api/types/workbookRuns.types";
import LockInCircleIcon from "@entrilia/shared/icons/LockInCircleIcon";
interface Props {
  isLocked: boolean;
  reportStatus: WorkbookRunStatus | undefined;
}

const WorkbookReportItemEndIcon = ({ isLocked, reportStatus }: Props) => {
  if (isLocked) {
    return (
      <Tooltip title="Report is locked for refreshing" disableInteractive>
        <LockInCircleIcon color="action" />
      </Tooltip>
    );
  }
  if (reportStatus === "Completed") {
    return <CheckCircleRoundedIcon color="success" />;
  }
  if (reportStatus === "Error") {
    return <CancelRoundedIcon color="error" />;
  }

  return null;
};

export default WorkbookReportItemEndIcon;
